<button
  class="btn btn-primary no-arrow float-right"
  (click)="openWarningModal()"
>
  Print Report&nbsp;
  <span class="icon-file"></span>
</button>
